import React from "react"
import styled from "styled-components"

const Embed = styled.div`  
  border:5px solid rgba(72, 75, 88, 0.5);
  border-radius:5px;
`


const Map = () => {
  return (
    <Embed className="embed-responsive embed-responsive-16by9">
      <iframe
        className="embed-responsive-item"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2938.5136052406333!2d-113.73793292348893!3d42.56561992208947!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54ab31350d495dd5%3A0x21ad971cac8710b7!2s340%20Centennial%20Dr%2C%20Heyburn%2C%20ID%2083336%2C%20USA!5e0!3m2!1sen!2sin!4v1711444387023!5m2!1sen!2sin"
        allowFullScreen=""
        loading="lazy"
        title="map"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </Embed>
  )
}

export default Map